module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal modal-footer",
    on: {
      "click": function($event) {
        _vm.$emit('close')
      }
    }
  }, [_c('div', {
    staticClass: "modal__content modal-footer__content"
  }, [_c('a', {
    staticClass: "modal-footer__btn modal-footer__office-1",
    attrs: {
      "href": "https://goo.gl/maps/nxrCgsiLjMr",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "modal-footer__btn-title"
  }, [_vm._v("Grand Prairie Orthodontic Office")]), _c('div', {
    staticClass: "modal-footer__btn-addy"
  }, [_c('div', {
    staticClass: "modal-footer__btn-addy-line"
  }, [_vm._v("325 West Westchester Parkway, #100")]), _c('div', {
    staticClass: "modal-footer__btn-addy-line"
  }, [_vm._v("Grand Prairie, TX 75052")])])]), _c('a', {
    staticClass: "modal-footer__btn modal-footer__office-1",
    attrs: {
      "href": "https://goo.gl/maps/avu6rof8aFD2",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "modal-footer__btn-title"
  }, [_vm._v("Midlothian Orthodontic Office")]), _c('div', {
    staticClass: "modal-footer__btn-addy"
  }, [_c('div', {
    staticClass: "modal-footer__btn-addy-line"
  }, [_vm._v("1131 George Hopper Rd, #200")]), _c('div', {
    staticClass: "modal-footer__btn-addy-line"
  }, [_vm._v("Midlothian, TX 76065")])])]), _c('a', {
    staticClass: "modal-footer__btn modal-footer__office-2",
    attrs: {
      "href": "https://goo.gl/maps/TAVcEzcHNkVMmEDy8",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "modal-footer__btn-title"
  }, [_vm._v("Dallas Orthodontic Office")]), _c('div', {
    staticClass: "modal-footer__btn-addy"
  }, [_c('div', {
    staticClass: "modal-footer__btn-addy-line"
  }, [_vm._v("2222 Fort Worth Ave, #110")]), _c('div', {
    staticClass: "modal-footer__btn-addy-line"
  }, [_vm._v("Dallas, TX  75208")])])]), _c('div', {
    staticClass: "modal-footer__arrow"
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3f877edf"}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/modal/footer/modal-footer.pug
// module id = 511
// module chunks = 1